export * from './baSlimScroll.directive';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/directives/baSlimScroll/index.ts